import { render, staticRenderFns } from "./CustomerPODButton.vue?vue&type=template&id=f88139ea"
import script from "./CustomerPODButton.vue?vue&type=script&lang=js"
export * from "./CustomerPODButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports